import React from "react";

import styles from "./PurchaseCard.module.scss";
import Button, { BUTTON_TYPES } from "../../components/button/Button";
import Icons from "../icons";
import { ICONS } from "../../constants/icons.constants";

const PurchaseCard = () => {
  return (
    <div className={styles.PurchaseCard}>
      <div className={styles.logo}>
        <Icons type={ICONS.LOGO} />
      </div>
      <div className={styles.box}>
        <div className={styles.check}>
          <Icons type={ICONS.CHECKLOGO} />
        </div>
        <p className={styles.desc}>You're Premium now.</p>
        <p className={styles.desc2}>
          Your purchase is complete. A receipt for order #1123235545 will be
          sent to your email. You will not be charged until after your trial
          expires on May 7, 2020. If you change your mind, you can cancel
          anytime by going to your Account.
        </p>
        <Button
          className={styles.btn}
          onClick={() => {
            // navigate(routesConstants.ROUTES.LOGIN);
          }}
          type={BUTTON_TYPES.PRIMARY}
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default PurchaseCard;
